import {
  GetAnalysisPipelineStep,
  isSidebarDatasetInitializationMultiOutputStepType,
  isSidebarDatasetInitializationSingleOutputStepType,
} from 'analysis-tool/AnalysisTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

/**
 * Find the Initialize Dataset pipeline steps that create a single output for the input pipeline.
 */
export function getInitializeSingleDatasetSteps(pipeline: PipelineGraphQL): Array<GetAnalysisPipelineStep> {
  return pipeline.execution.steps.filter((step) =>
    isSidebarDatasetInitializationSingleOutputStepType(step.definition.stepType)
  );
}

/**
 * Find the Initialize Dataset pipeline steps that create multiple outputs for the input pipeline.
 */
export function getInitializeMultiDatasetSteps(pipeline: PipelineGraphQL): Array<GetAnalysisPipelineStep> {
  return pipeline.execution.steps.filter((step) =>
    isSidebarDatasetInitializationMultiOutputStepType(step.definition.stepType)
  );
}

/**
 * Find the non-Initialize Single Dataset pipeline steps for the input pipeline.
 *
 * Legacy, is only used by the legacy pipeline sidebar component.
 */
export function getNonInitializeSingleDatasetSteps(
  pipeline: PipelineGraphQL
): Array<GetAnalysisPipelineStep> {
  return pipeline.execution.steps.filter(
    (step) => !isSidebarDatasetInitializationSingleOutputStepType(step.definition.stepType)
  );
}
